import { LocalStorage } from "../services/storage";

export const getParsedLocalStorage = (key: string, fallback: any): any => {
  try {
    const data = LocalStorage.get(key);
    return data ? JSON.parse(data) : fallback;
  } catch {
    console.log("Error parsing local storage data. Returning fallback value.");
    return fallback;
  }
};